var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useState, useEffect } from 'react';
import styled from '../../../../styled';
import * as Icons from '../../../icons';
import * as Tooltip from '../../../tooltip';
import TooltipView from '../../../tooltip/TooltipView';
import { StyledInput } from '../../../input';
import { ClearBtnWrapper, DateInputIconWrapper, Wrapper, InputWrapper as InputWrapperComponent, } from './DateInput';
const ArrowIconWrapper = styled.div `
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin-left: 0.0625rem;
  margin-right: 0.0625rem;
`;
const InputWrapper = styled(InputWrapperComponent) `
  .tooltip-container {
    display: inline-block;
    flex: unset;
    vertical-align: bottom;

    > div:last-of-type {
      height: 2.25rem;
      display: flex;
    }
  }
`;
const DateRangeInput = (_a) => {
    var { lang, status = 'valid', block = false, disabled, fromRef, toRef, inputSize = 'MEDIUM', selectedFrom, selectedTo, valueFrom, valueTo, placeholders = [], tooltipText, tooltipDirection = 'TOP_CENTER', clearBtnTooltipText, onClearBtnClick } = _a, restProps = __rest(_a, ["lang", "status", "block", "disabled", "fromRef", "toRef", "inputSize", "selectedFrom", "selectedTo", "valueFrom", "valueTo", "placeholders", "tooltipText", "tooltipDirection", "clearBtnTooltipText", "onClearBtnClick"]);
    const [isFocus, setIsFocus] = useState(false);
    const [isShowTooltip, setIsShowTooltip] = useState(false);
    const [isShowClearBtn, setIsShowClearBtn] = useState(false);
    const handleBlur = () => {
        setIsFocus(false);
        setIsShowTooltip(false);
    };
    const handleWrapperMouseEnter = useCallback(() => {
        if (selectedFrom && selectedTo)
            setIsShowClearBtn(true);
    }, [selectedFrom, selectedTo]);
    const handleWrapperMouseLeave = useCallback(() => {
        setIsShowClearBtn(false);
    }, []);
    const handleClearBtnClick = useCallback((e) => {
        e.stopPropagation();
        if (!fromRef || !fromRef.current)
            return;
        fromRef.current.focus();
        setIsShowClearBtn(false);
        setIsShowTooltip(true);
        if (onClearBtnClick)
            onClearBtnClick(e);
    }, [fromRef, onClearBtnClick]);
    useEffect(() => {
        if (!fromRef || !fromRef.current || !toRef || !toRef.current)
            return () => { };
        const fromInput = fromRef.current;
        const toInput = toRef.current;
        const handleFocus = () => {
            setIsFocus(true);
            setIsShowTooltip(fromInput.value.length === 0 && toInput.value.length === 0);
        };
        const handleKeyup = (e) => {
            if (e.target === toInput && (e.keyCode || e.which) === 13) {
                setIsShowTooltip(false);
                return;
            }
            setIsShowTooltip(isFocus && fromInput.value.length === 0 && toInput.value.length === 0);
        };
        // init
        fromInput.addEventListener('focus', handleFocus);
        toInput.addEventListener('focus', handleFocus);
        fromInput.addEventListener('keyup', handleKeyup);
        toInput.addEventListener('keyup', handleKeyup);
        return () => {
            fromInput.removeEventListener('focus', handleFocus);
            toInput.removeEventListener('focus', handleFocus);
            fromInput.addEventListener('keyup', handleKeyup);
            toInput.addEventListener('keyup', handleKeyup);
        };
    }, [fromRef, isFocus, toRef]);
    useEffect(() => {
        // hide tooltip after selecting a new valid date from calendar view
        if (selectedFrom || selectedTo)
            setIsShowTooltip(false);
    }, [selectedFrom, selectedTo]);
    return (React.createElement(Wrapper, { disabled: disabled, focused: isFocus, onMouseEnter: handleWrapperMouseEnter, onMouseLeave: handleWrapperMouseLeave, onBlur: handleBlur, status: status, block: block },
        React.createElement(InputWrapper, { disabled: disabled },
            React.createElement(StyledInput, Object.assign({ ref: fromRef, type: "input", status: "valid", disabled: disabled, inputSize: inputSize, value: valueFrom, placeholder: placeholders[0] }, restProps)),
            React.createElement(TooltipView, { type: "primary", lang: lang, text: tooltipText, show: isShowTooltip, direction: tooltipDirection, containerClassName: "tooltip-container" },
                React.createElement(ArrowIconWrapper, null,
                    React.createElement(Icons.Outline.Arrow, { position: "RIGHT", color: "INK_600", size: "MEDIUM" }))),
            React.createElement(StyledInput, Object.assign({ ref: toRef, type: "input", status: "valid", disabled: disabled, inputSize: inputSize, value: valueTo, placeholder: placeholders[1] }, restProps))),
        React.createElement(Tooltip.Primary, { lang: lang, text: clearBtnTooltipText, direction: tooltipDirection },
            React.createElement(ClearBtnWrapper, { show: isShowClearBtn, inputSize: inputSize, onClick: handleClearBtnClick },
                React.createElement(Icons.Outline.Cross, { color: "INK_600", size: "SMALL" }))),
        React.createElement(DateInputIconWrapper, { show: !isShowClearBtn, disabled: disabled, inputSize: inputSize, onClick: handleClearBtnClick },
            React.createElement(Icons.Outline.Calendar, { color: "INK_600", size: "MEDIUM" }))));
};
export default DateRangeInput;
//# sourceMappingURL=DateRangeInput.js.map